module.exports = __webpack_public_path__ + "img/bannerGreen.d1ccc404.jpg";